import { observer } from "mobx-react-lite";
import React from "react";

import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";
import { useFixBody } from "@state/hooks/shared";
import { DetailsTypeEnum } from "@state/stores/account-statement/AccountStatementStore";
import {
	AccountStatementBetDetails,
	AccountStatementTransactionDetails,
} from ".";

export const AccountStatementPopupDetails = observer(
	function AccountStatementPopupDetails() {
		const store = useAccountStatementStore();
		useFixBody(
			true,
			store.accountStatementDetailsStore.detailsType !==
				DetailsTypeEnum.None
		);

		if (
			store.accountStatementDetailsStore.detailsType ==
			DetailsTypeEnum.BetSlipDetails
		) {
			return <AccountStatementBetDetails />;
		}

		if (
			store.accountStatementDetailsStore.detailsType ==
			DetailsTypeEnum.TransactionDetails
		) {
			return <AccountStatementTransactionDetails />;
		}
		return null;
	}
);
